import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  ropJoinNowData: {},
  isLoading: false,
  error: "",
  hasData: false
};
const fetchJoinNowSlice = createSlice({
  name: "ropJoin",
  initialState,
  reducers: {
    getJoinNowRequest: state => {
      state.isLoading = true;
    },
    getJoinNowSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.error = "";
      state.ropJoinNowData = action?.payload;
    },
    getJoinNowFailure: (state, action) => {
      state.isLoading = false;
      state.hasData = false;
      state.error = action?.payload?.response?.data;
      state.ropJoinNowData = {};
    }
  }
});
export const {
  getJoinNowRequest,
  getJoinNowSuccess,
  getJoinNowFailure
} = fetchJoinNowSlice.actions;
export default fetchJoinNowSlice.reducer;